export const CorporatePermissions = {
  ['download_exports']: 101n,
  ['read_controls']: 102n,
  ['write_controls']: 103n,
  ['bi_view_only']: 104n,
  ['bi_exports']: 105n,
  ['bi_explorer']: 106n,
  ['clients__corporate_merge']: 107n,
  ['pii__view_contact_details']: 108n,
  ['pii__view_full_identity']: 109n,
  ['pii__export_pii']: 110n,
  ['content__read']: 111n,
  ['content__write']: 112n,
  ['content__publish']: 113n,
  ['content__delete']: 114n,
  ['content__moderate']: 115n,
  ['content__configure_permissions']: 116n,
  ['content__view_analytics']: 117n,
  ['marketplace__manage_integrations']: 118n,
  // OC-320 product tiering. RESERVED, not yet enforced — impersonation plus the `product-tiering`
  // flag are the gate for this pass; these get wired to @RequirePermissions and the access-policy
  // UI in Phase 2. Appended after the current max (118n); the retired gaps are not reused.
  ['manage_plan']: 119n,
  ['manage_add_ons']: 120n,
  // INT-821. Was 119n on this branch; renumbered past OC-320's pair, which took 119n/120n on main
  // first. Nothing has been persisted at the old bit — the branch has never shipped.
  ['bi_admin']: 121n,
  // OC-554 member movement. Appended after main's current max — these bits are unshipped, so they
  // yield to any value already on main rather than the other way round (bit positions are the
  // persisted contract in the computedPermissions bitmap). Third renumber: 118 -> 119 -> 121 -> 122
  // as marketplace, OC-320 and INT-821 each landed on trunk first.
  ['member_movement__view']: 122n,
  ['member_movement__configure']: 123n,
  ['member_movement__approve']: 124n,
  // Took 147n on its branch; renumbered on the main merge that had shipped 147-156n.
  ['security__allowed_networks__manage']: 157n,
  // Took 153-154n, 161-162n, then 162-163n, on its branch; renumbered on main merges that had shipped 149-159n.
  ['corporate__commissions__manage']: 164n,
  ['corporate__commissions__periods']: 165n,
  // Took 150n, 158n, 159n, 160n, 167n, 169n, 170n, 172n, 181n, then 182n, on its branch; renumbered on main merges that had shipped 150-182n.
  ['view_member_as_admin']: 183n,
} as const

export type CorporatePermissionsKey = keyof typeof CorporatePermissions
